document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.shopify-section--ds-featured-collections, .shopify-section--ds-sale-products');

  sections.forEach(section => {
    const collectionNavButtons = section.querySelectorAll('.ds-collection-nav-button');
    const collectionContents = section.querySelectorAll('.ds-featured-collections__content-wrapper[data-collection-id]');
    const productDisplays = section.querySelectorAll('.ds-featured-collections-products');
    const sectionId = section.id.replace('shopify-section-', '');
    const viewAllContainer = document.getElementById(`view-all-link-${sectionId}`);
    // the link is either the element itself or the button rendered inside it
    const viewAllLink = viewAllContainer?.tagName === 'A' ? viewAllContainer : viewAllContainer?.querySelector('a');

    // Funktion zum Aktualisieren des "View All" Links
    function updateViewAllLinks(collectionUrl, collectionTitle) {
        if (collectionUrl && viewAllLink) {
            viewAllLink.href = collectionUrl;
            viewAllLink.setAttribute('aria-label', collectionTitle);
        }
    }

    function collectionButtonClick(event) {
        event.preventDefault();
        
        // Collection ID und URL vom geklickten Button holen
        const collectionId = event.currentTarget.getAttribute('data-collection-id');
        const collectionUrl = event.currentTarget.getAttribute('data-collection-url');
        const collectionTitle = event.currentTarget.getAttribute('data-collection-title');
        
        // Aktiven Status für Buttons aktualisieren
        collectionNavButtons.forEach(button => {
            if (button.getAttribute('data-collection-id') === collectionId) {
                button.classList.remove('inactive');
            } else {
                button.classList.add('inactive');
            }
        });
        
        // Ausgewählten Collection-Inhalt anzeigen und andere ausblenden
        collectionContents.forEach(content => {
            const contentId = content.getAttribute('data-collection-id');
            if (contentId === collectionId) {
                content.classList.remove('hidden');
            } else {
                content.classList.add('hidden');
            }
        });
        
        // Ausgewählte Produkte anzeigen und andere ausblenden
        let foundMatchingProducts = false;
        productDisplays.forEach(display => {
            const displayId = display.getAttribute('data-collection-id');
            
            if (displayId === collectionId) {
                display.style.display = 'block';
                foundMatchingProducts = true;
            } else {
                display.style.display = 'none';
            }
        });
        
        if (!foundMatchingProducts) {
            console.warn('Keine passenden Produkte gefunden für Collection ID:', collectionId);
        }

        // Scroll-Carousel zurücksetzen
        const scrollCarousel = section.querySelector('scroll-carousel');
        if (scrollCarousel) {
            // Scroll zum Anfang zurücksetzen
            scrollCarousel.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
        }

        // "View All" Links mit der URL der ausgewählten Collection aktualisieren
        updateViewAllLinks(collectionUrl, collectionTitle);
    }

    // Click-Event-Listener zu allen Collection-Navigationsbuttons hinzufügen
    collectionNavButtons.forEach(button => {
        button.addEventListener('click', collectionButtonClick);
    });

    // Anfangszustand einrichten
    function setupInitialState() {
        // Ersten Collection-Button und seine ID holen
        const firstButton = collectionNavButtons[0];
        
        if (firstButton) {
            const initialCollectionId = firstButton.getAttribute('data-collection-id');
            const initialCollectionUrl = firstButton.getAttribute('data-collection-url');
            const initialCollectionTitle = firstButton.getAttribute('data-collection-title');
            
            // Ersten Button als aktiv setzen
            firstButton.classList.remove('inactive');
            
            // Alle Collection-Inhalte und Produkte außer dem ersten ausblenden
            collectionContents.forEach(content => {
                if (content.getAttribute('data-collection-id') === initialCollectionId) {
                    content.classList.remove('hidden');
                } else {
                    content.classList.add('hidden');
                }
            });
            
            productDisplays.forEach(display => {
                if (display.getAttribute('data-collection-id') === initialCollectionId) {
                    display.style.display = 'block';
                } else {
                    display.style.display = 'none';
                }
            });

            // "View All" Links mit der URL der ersten Collection initialisieren
            updateViewAllLinks(initialCollectionUrl, initialCollectionTitle);
        }
    }
    
    // Anfangszustand einrichten
    setupInitialState();
  });
});
